<template>
    <div class="login-content">
        <div class="mask"></div>
        <div class="login-form">
            <div class="left-side">
                <div class="logo"></div>
                <div class="title">欢迎使用</div>
                <div class="sub-title">用户权限管理</div>
            </div>
            <Form ref="formValidate" :model="ruleForm" :rules="rules" label-position="top" class="right-form">
                <FormItem label="" prop="username">
                    <Input v-model="ruleForm.username" placeholder="输入用户名" clearable>
                    <Icon type="ios-person-outline" slot="prepend"></Icon>
                    </Input>
                </FormItem>
                <FormItem label="" prop="password">
                    <Input v-model="ruleForm.password" type="password" placeholder="输入密码" @keyup.enter.native="handleLogin" clearable>
                    <Icon type="ios-lock-outline" slot="prepend"></Icon>
                    </Input>
                </FormItem>
                <FormItem>
                    <Button class="login-btn" :loading="loading" type="primary" @click="handleLogin" icon="md-exit" size="large">登录</Button>
                </FormItem>
            </Form>
        </div>
        <div class="copyright">Copyright200229.1.01</div>
    </div>
</template>

<script>
import api from '../common/api'
import '../common/md5'
import common from '../common/common'
import config from '../config'

export default {
    name: 'Login',
    data() {
        return {
            ruleForm: {
                username: '',
                password: ''
            },
            rules: {
                username: [
                    { required: true, message: '用户名不能为空', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '密码不能为空', trigger: 'blur' }
                ],
            },
            loading: false,
            redirectUrl: '', // 登录后回跳的页面路径
        }
    },
    created() {
        this.redirectUrl = this.$route.query[config.loginRedirectParam] || ''
    },
    methods: {
        handleLogin() {
            this.$refs.formValidate.validate((valid) => {
                if (valid) {
                    this.loading = true;
                    const pwd = window.md5(this.ruleForm.password);
                    // const pwd = this.ruleForm.password;
                    const params = {
                        appCode: '',
                        cacheUuidKey: '',
                        loginType: '',
                        password: pwd,
                        username: this.ruleForm.username,
                        verifyFlag: false,
                        verifycationCode: ''
                    }
                    api.login(params).then((res) => {
                        this.loading = false;
                        if (res.resultCode !== 0 || !res.data) {
                            this.$Message.error(res.resultMessage || '登录失败');
                        } else {
                            const { token } = res.data
                            if (!res.data.isMaster && res.data.loginName !== 'root') {
                                this.$Message.error('无权限登录')
                                return
                            }
                            this.unifiedUserLoginSetRoute(res.data);
                            common.setLocalToken(token);
                            if (this.redirectUrl) {
                                window.location.href = this.redirectUrl
                            } else {
                                window.location.href = '/'
                            }
                        }
                    }).catch((e) => {
                        this.loading = false;
                        this.$Message.success(e.message || '登录失败');
                    })
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
    .login-content{
        position: relative;
        width: 100%;
        height: 100%;
        background: #F8F9FB;
        .login-form{
            position: relative;
            margin: auto;
            top:40%;
            transform: translate3d(0, -50%, 0);
            background: url("../assets/login_bg.png");
            width: 1200px;
            height: 440px;
            display: flex;
            justify-content: center;
            padding-top: 292px;
        }
        .left-side{
            position: relative;
            width: 480px;
            height: 200px;
            background: #1E212C;
            border: 1px solid #242835;
            border-radius: 4px 0px 0px 4px;
            .logo{
                background: url("../assets/logo.png") no-repeat;
                background-size: 100% 100%;
                width: 70px;
                height: 70px;
                position: absolute;
                left:51px;
                top:-40px;
            }
            .title{
                position: relative;
                margin: 54px 0 0 51px;
                font-size: 26px;
                font-family: PingFang SC;
                font-weight: 400;
                color: #E0E0E0;
                line-height: 36px;
            }
            .sub-title{
                position: relative;
                margin: 19px 0 0 51px;
                font-size: 20px;
                font-family: Lantinghei SC;
                font-weight: 600;
                color: #FFFFFF;
                line-height: 28px;
                opacity: 0.6;
            }
        }
        .right-form{
            position: relative;
            width: 480px;
            height: 200px;
            background: #FFFFFF;
            border-radius: 0px 4px 4px 0px;
            padding: 45px 0 0 30px;
        }
        .form-title{
            font-size: 18px;
            font-weight: 600;
            color: #364f6c;
            line-height: 50px;
            text-align: center;
        }
    }
    .ivu-input-wrapper{
        border-bottom: 1px solid #EEEEEE;
        width: 287px;
        .ivu-icon{
            font-size: 22px;
            color: #354052;
            font-weight: bold;
        }
    }
    /deep/ .right-form .ivu-input{
        outline: none;
        border: none !important;
        box-shadow: none;
        color: #354052 !important;
        background: none !important;
        &:focus{
            outline: none;
            border: none;
            box-shadow: none;
            background: none !important;
        }
    }
    /deep/ .ivu-btn-primary {
        border: 0;
    }
    .login-btn{
        position: absolute;
        right: 55px;
        top: -64px;
    }
    .copyright{
        position: absolute;
        bottom: 30px;
        width: 100%;
        text-align: center;
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #9b9b9b;
        line-height: 12px;
    }
</style>
